import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_methods: {
    delivery: 'Levering',
    pickup: 'Afhentning',
  },
  asap: 'Hurtigst muligt',
  unavailable: 'Ikke tilgængelig',
  ready_in_time: 'Klar om {{time}} min.',
  locations: {
    [ORDER_METHODS.DELIVERY]: 'Levering til {{address}}',
    [ORDER_METHODS.PICKUP]: 'Afhentning på {{address}}',
  },
  buttons: {
    change: 'Skift',
    see_hours: 'Se åbningstider',
    change_location: 'Skift lokation',
    change_time: 'Skift tidspunkt',
  },
};
